// Hide the floating contact button while the product buy buttons are on screen,
// so it never covers Add to cart. The contact entry returns once the buy box scrolls away.
(() => {
  const target = document.querySelector('product-form .product-form__buttons, .product-form__buttons');
  if (!target || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) document.body.dataset.filerBuybox = 'visible';
    else delete document.body.dataset.filerBuybox;
  }, { rootMargin: '0px 0px 120px 0px' }).observe(target);
})();
